const MAX_WIDTH_MOBILE = 767;

const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const isMobile = () => getWidth() <= MAX_WIDTH_MOBILE;

const setCustomHeightVariable = () => {
    const vh = window.innerHeight * 0.01; /* eslint-disable-line */
    // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export {
    setCustomHeightVariable,
    isMobile
};
